import { Injectable } from "@angular/core";
import { timer } from "rxjs";


@Injectable({
    providedIn: 'root',
  })
export class LoadProgressTextService
{
    private loading: boolean = false;
    private loadProgress: string = "";
    private loadTimer: any;

    isLoading(): boolean
    {
        return this.loading;
    }

    showLoadingText(): void
    {
        this.start();
        this.loading = true;
    }

    hideLoadingText(): void
    {
        this.stop();
        this.loading = false;
    }

    private loadingHandler(time): void
    {
        if(time % 4 == 0)
        {
            this.loadProgress = "טוען נתונים";
        }
        else if(time % 4 == 1)
        {
            this.loadProgress = "טוען נתונים.";
        }
        else if(time % 4 == 2)
        {
            this.loadProgress = "טוען נתונים..";
        }
        else if(time % 4 == 3)
        {
            this.loadProgress = "טוען נתונים...";
        }
    }

    private start(): void
    {
        this.loadTimer = timer(0, 300)
            .subscribe(
            time => this.loadingHandler(time)
        );
    }

    private stop(): void
    {
        this.loadTimer.unsubscribe();
    }
}
